// removed by extract-text-webpack-plugin
module.exports = {"polarBear":"#f2f3f5","this":"ClassNavigation__this___2_aJN","divider":"ClassNavigation__divider___Xswf-","classList":"ClassNavigation__classList___d-cLN"};


//////////////////
// WEBPACK FOOTER
// ./src/groups/components/styles/ClassNavigation.css
// module id = 2335
// module chunks = 0 1